module.exports = __webpack_public_path__ + "img/right-arrow.e8206ade.svg";